"use client"
 
import { useState } from "react"
import { LeaveManagementPage } from "../../modules/leave-management/leave-management-page"

interface LeaveManagementProps {
  sidebarOpen?: boolean
}

export default function LeaveManagement({sidebarOpen }: LeaveManagementProps) {
  return <LeaveManagementPage />
}
